import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';
import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
  {
    type: 'html:attr',
    name: 'widget',
    refreshType: 'all',
    property: 'data-widget',
    targetSelector: '.module',
    options: [
      {
        key: 'related',
        value: 'Related Products',
      },
    ],
    default_value: 'ralate',
  },
];
/**
 * GpBoldSubscriptions Class
 */
export class GpBoldSubscriptions extends GpThirdParty {
  public $el: JQuery;
  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Bold Subscriptions';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'bold-subscriptions';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
